import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Text,
	Link,
	OrderedList,
	ListItem,
	UnorderedList,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const TheContextGlobalPowerHouse: React.FC = () => (
	<>
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "400px", sm: "350px" }}
			minH={{ xs: "400px", sm: "350px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDirection="column"
			>
				<Flex
					alignItems={{ xs: "flex-start", md: "flex-start" }}
					justifyContent="center"
					columnGap="24px"
					justifyItems="center"
					width="100%"
					display="flex"
					as="section"
					rowGap="30px"
					flexDir={{
						xs: "column",
						md: "row",
					}}
				>
					<Flex flexDir="column" rowGap="16px">
						<Heading
							color="white"
							fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
							fontWeight="800"
							lineHeight={{ xs: "35px", lg: "83px" }}
						>
							#TheContext
						</Heading>
					</Flex>
					<Box
						w="1.5px"
						h={{ xs: "100%" }}
						bgColor="white"
						display={{ xs: "none", md: "block" }}
					/>
					<Box
						w={{ xs: "70%", sm: "60%" }}
						h="1.5px"
						bgColor="white"
						display={{ xs: "block", md: "none" }}
					/>
					{/*  */}
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						China + 1: How is India Transforming into a Global Manufacturing
						Powerhouse
					</Heading>
				</Flex>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "40px" }}
				mb="20px"
			>
				<Flex
					flexDir={{
						xs: "column",
						md: "row",
					}}
					gap="20px"
					alignItems={{
						xs: "center",
						md: "unset",
					}}
				>
					<Img
						src="https://static.levocdn.com/WGLBUT82/ratnamehta-1d7hL5fDfrih.png"
						alt="Ratna Mehta"
						width="250px"
						height="250px"
						objectFit="contain"
						borderRadius="50%"
					/>
					<Flex direction="column">
						<Heading
							as="h1"
							fontWeight="800"
							pt="20px"
							variant="reportCardTitle"
							fontSize={{ xs: "16px", md: "18px", lg: "20px" }}
							textAlign={{
								xs: "center",
								md: "left",
							}}
						>
							Ratna Mehta
							<Link
								href="https://www.linkedin.com/in/ratnamehta"
								target="_blank"
								display={{ xs: "inline-block", md: "none" }}
								pl={"10px"}
							>
								<IconButton
									aria-label="linkedin"
									icon={<FaLinkedin size="28px" color="#067acc" />}
									variant="unstyled"
									cursor="pointer"
								/>
							</Link>
						</Heading>
						<Text
							color="text.mediumBlack"
							maxW={{
								xs: "100%",
								md: "120px",
							}}
							w="100%"
							fontSize="16px"
							lineHeight="22px"
							//   fontStyle="italic"
							textAlign={{
								xs: "center",
								md: "left",
							}}
						>
							CEO & Managing Partner, Fundalogical Ventures
						</Text>

						<Link
							href="https://www.linkedin.com/in/ratnamehta"
							target="_blank"
							display={{
								xs: "none",
								md: "block",
							}}
						>
							<IconButton
								aria-label="linkedin"
								icon={<FaLinkedin size="28px" color="#067acc" />}
								variant="unstyled"
								cursor="pointer"
							/>
						</Link>
					</Flex>
				</Flex>
			</Box>
			<Box>
				<Box mt="16px" mb="20px">
					<Text variant="blogAnswer">
						Since the dawn of time, economies have grown alongside manufacturing
						revolutions — such as the United States (U.S.) during the 1970s,
						Japan during the 1910s, and even Germany during the 1900s.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" pt="8px">
						Today, China dominates global manufacturing with a ~30% share,
						followed by the U.S. at ~16%, Japan at ~7%, and Germany at ~5%.
						However, China grapples with weakening political relations and
						logistical challenges, the U.S. with labour shortages and higher
						costs, and Germany’s supremacy witnessing challenges, thus, creating
						opportunities for emerging players such as India. This article
						explores the evolving landscape of global manufacturing and India's
						rising role as a beneficiary of this evolving landscape.
					</Text>
				</Box>
				<Box my="16px">
					<Heading variant="blogQuestion" mb="20px" pt="12px">
						A. How is Germany losing supremacy over manufacturing & can India be
						a beneficiary?
					</Heading>
					<Text variant="blogAnswer" mt="16px" mb="8px">
						For decades, Germany had been an industrial powerhouse (
						<Text as="span" variant="blogQuestion" fontWeight="700">
							accounting for ~23% of its GDP
						</Text>
						) with nearly{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							50% of its economy running on exports
						</Text>
						. Germany has always been an energy dependent economy, with
						industries such as chemicals, pharma, glass, metals and paper
						contributing to 20% of its manufacturing industry (2022).
						<br />
						<br />
						However, Germany's economic output fell 0.3% in 2023 with
						energy-intensive production down 11% - driven by 3 key factors –{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							higher energy prices, Germany’s net-zero energy policy, and a
							slowdown in China
						</Text>{" "}
						(a key trade partner to Germany).
						<br />
						<br />
						Russia contributes ~55% of Germany’s natural gas imports; Russia’s
						invasion of Ukraine and the destruction of the Nord Stream (a
						connecting natural gas pipeline), ended Germany’s business model
						that was based on manufacturing using cheap energy imports and
						industrial exports.
						<br />
						<br />
						Another factor has been Germany’s dependence on China’s demand.
						After peaking in 2022, German exports to China fell by 9% in 2023.
						This was led by a slowdown in China and a change in the competitive
						landscape (pressure from local competition in China due to their
						policies favouring domestic firms). Thus, in July 2023, the German
						government published a ‘China + 1’ strategy, advocating for economic
						diversification away from China. Research from the German Chamber of
						Commerce in China suggests that nearly{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							60% of companies surveyed said they would be investing more in
							India
						</Text>
						, similarly, ~40% for Vietnam, 30% for Thailand, ~25% for Malaysia
						and 20% for Singapore
						<br />
						<br />
						Research from KPMG suggests that India is becoming an important
						cornerstone of Germany’s de-risking strategy across purchase,
						production and also in R&D. By 2028,{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							~25% of German companies want to use India for their R&D and 53%
							want to produce in India.
						</Text>
					</Text>
				</Box>

				<Box my="16px">
					<Heading variant="blogQuestion" mb="20px" pt="12px">
						B. Transformation of the Indian manufacturing driven by strong
						international relations and geographical advantage
					</Heading>
					<Text variant="blogAnswer" mt="16px" mb="8px">
						China + 1 is not just a buzz word – there is actual evidence and
						interest towards India, Mexico, Vietnam, Thailand and Indonesia.
						<br />
						<br />
						Research from BCG suggests that{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							more than 90% of the North American manufacturers surveyed have
							relocated production
						</Text>{" "}
						or part of their supply base from China to other countries over the
						last 5 years and is expected to continue over the next 5 years.
						Moreover, manufacturers are willing to give up more than 2% in gross
						margins to operate with shorter lead times and make their supply
						chains resilient.
						<br />
						<br />
						Companies are already shifting operations to India - according to
						market research firm OnePoll, ~60% of 500 executive-level U.S.
						managers surveyed said{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							they would pick India over China
						</Text>{" "}
						if both could manufacture the same materials.
						<br />
						<br />
						The value of announced{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							U.S. and European greenfield investment into India shot up by ~US
							$65B (400%) between 2021 and 2022, while investment into China
							dropped to less than $20B in 2022, from a peak of $120B in 2018.
						</Text>{" "}
						<br />
						<br />
						Ties between American companies and India, as a manufacturing and
						supply chain partner, are getting deeper on the back of political
						friendliness of the US Secretary of Commerce with Asian countries.
						<br />
						<br />
					</Text>
					<UnorderedList>
						<ListItem>
							<Text as="span" variant="blogAnswer" py="16px">
								Boeing currently has 5,000 employees and{" "}
								<Text as="span" variant="blogAnswer" fontWeight="700">
									has invested $1B with 300 suppliers
								</Text>{" "}
								in its supply chain in India. Boeing is not only selling planes
								to Indian carriers but also making several components along with
								the Tata group in their 14000 sq. m manufacturing facility in
								Telangana. They have also announced investments in setting up
								its{" "}
								<Text as="span" variant="blogAnswer" fontWeight="700">
									‘Global Support Center and Logistics Center’
								</Text>{" "}
								in India.
							</Text>
						</ListItem>

						<ListItem>
							<Text as="span" variant="blogAnswer" py="16px">
								Apple and its suppliers are{" "}
								<Text as="span" variant="blogAnswer" fontWeight="700">
									aiming to build more than 50M iPhones in India annually
								</Text>{" "}
								within the next 2-3 years. If the plans are achieved, India
								would account for{" "}
								<Text as="span" variant="blogAnswer" fontWeight="700">
									25% of global iPhone production from the current ~7%
								</Text>{" "}
								in FY 23. Japanese company TDK, a supplier of cells to Apple, is
								setting up a 180-acre facility in Manesar, Haryana to build
								cells for batteries used in the iPhones.
							</Text>
						</ListItem>
						<ListItem>
							<Text as="span" variant="blogAnswer" py="16px">
								Google has directed suppliers to{" "}
								<Text as="span" variant="blogAnswer" fontWeight="700">
									commence production of its Pixel 8 smartphones in India
								</Text>{" "}
								by establishing a factory in South India.
							</Text>
						</ListItem>
						<ListItem>
							<Text as="span" variant="blogAnswer" py="16px">
								Tesla has also been talking with the government to finalise a
								package of incentives that could include lower import duties for
								EVs in return for a{" "}
								<Text as="span" variant="blogQuestion" fontWeight="700">
									$2B investment in a proposed EV facility in India
								</Text>
								.
							</Text>
						</ListItem>
						<ListItem>
							<Text as="span" variant="blogAnswer" py="16px">
								Walmart has a{" "}
								<Text as="span" variant="blogAnswer" fontWeight="700">
									target of sourcing $10B worth of goods from India
								</Text>{" "}
								annually by 2027 and is already exporting $3B worth of goods.
							</Text>
						</ListItem>
					</UnorderedList>
				</Box>

				<Box my="16px">
					<Heading variant="blogQuestion" mb="20px" pt="12px">
						B1. Measures by the Government
					</Heading>
					<Text variant="blogAnswer" py="16px">
						The government has taken a slew of measures to make India an
						attractive and competitive destination for manufacturing and
						exports.
						<br />
						<br />
					</Text>
					<UnorderedList>
						<ListItem>
							<Text as="span" variant="blogAnswer" py="16px">
								<Text as="span" variant="blogAnswer" fontWeight="700">
									PLI (Production Linked Incentive Schemes):
								</Text>{" "}
								This has been a game-changer as it has helped increase
								manufacturing activity in the country across 14 sectors and has
								attracted investments of over{" "}
								<Text as="span" variant="blogAnswer" fontWeight="700">
									Rs 1 lakh crore
								</Text>{" "}
								as of 2023, resulting{" "}
								<Text as="span" variant="blogAnswer" fontWeight="700">
									in production and sales amounting to over Rs 8.5 lakh crore.
								</Text>{" "}
							</Text>
						</ListItem>
						<ListItem>
							<Text as="span" variant="blogAnswer" py="16px">
								<Text as="span" variant="blogAnswer" fontWeight="700">
									FTAs (Free Trade Agreements):
								</Text>{" "}
								India has signed{" "}
								<Text as="span" variant="blogAnswer" fontWeight="700">
									13 FTAs with 22 countries
								</Text>{" "}
								with the key ones being Mauritius, UAE and Australia and
								currently engaged in negotiations with multiple countries
								including Oman, the UK, the EU, Canada, and various Indo-Pacific
								Economic Framework (IPEF) partner countries.
							</Text>
						</ListItem>
						<ListItem>
							<Text as="span" variant="blogAnswer" py="16px">
								<Text as="span" variant="blogAnswer" fontWeight="700">
									Liberalisation of FDI norms:
								</Text>{" "}
								The government has liberalized FDI policies{" "}
								<Text as="span" variant="blogAnswer" fontWeight="700">
									allowing 100% investment
								</Text>{" "}
								in many sectors such as pharmaceuticals (greenfield & brownfield
								investments), defence manufacturing, e-commerce services and
								food processing.
							</Text>
						</ListItem>
						<ListItem>
							<Text as="span" variant="blogAnswer" py="16px">
								<Text as="span" variant="blogAnswer" fontWeight="700">
									Gati Shakti:
								</Text>{" "}
								The Rs 100 lakh crore Gati Shakti project is helping expand the
								logistical network in India at a faster pace and improve India’s
								multi-modal connectivity. Until now,{" "}
								<Text as="span" variant="blogAnswer" fontWeight="700">
									~Rs 12 lakh crore
								</Text>{" "}
								worth of projects have already been sanctioned.
							</Text>
						</ListItem>
					</UnorderedList>
				</Box>

				<Box my="16px">
					<Heading variant="blogQuestion" mb="20px" pt="12px">
						B2. India's Export Surge: Breaking Down the Numbers
					</Heading>
					<Text variant="blogAnswer" py="16px">
						While US goods{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							imported from China declined by 10% from 2018 - 2022
						</Text>{" "}
						, they rose by 44% from India (by $23B), 18% from Mexico, and 65%
						from other ASEAN countries. Chinese exports to US for semiconductors
						decreased by 29% from China from 2018 - 2022 but{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							increased by 143% for India.
						</Text>{" "}
						Similarly, for auto components, Chinese exports witnessed a 12%
						decrease, but Indian exports saw a{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							65% increase.
						</Text>
					</Text>
					<Img src="/png/thecontext/thecontextpowerhouse2.png" width="100%" />
				</Box>
				<Box my="16px">
					<Heading variant="blogQuestion" mb="20px" pt="12px">
						B3. India's Unique Edge in Global Manufacturing
					</Heading>
					<Text variant="blogAnswer" py="16px">
						While India, Mexico and other SE Asia countries (Vietnam, Thailand,
						Indonesia etc.) are emerging as future export manufacturing
						countries, offering competitive cost structures and abundant labour;{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							India stands out with its large domestic market, helping companies
							with cheaper production costs + access to additional demand
						</Text>
						.
						<br />
						<br />
						<Img src="/png/thecontext/thecontextpowerhouse1.png" width="100%" />
						<br />
						Moreover, India provides a higher advantage in direct manufacturing
						costs (15% lower than the US, compared to China’s 4%. Additionally,
						some Chinese goods are subject to 21% higher on the back of trade
						war punitive tariffs.
						<br />
						<br />
						In conclusion, as global economic dynamics shift,{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							India is emerging as a viable alternative to traditional
							manufacturing powerhouses
						</Text>{" "}
						such as Germany and China. India's attractive cost structures,
						supportive government policies, large domestic market and
						competitive manufacturing costs add to the 'China + 1' strategy
						making{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							India a promising destination for global manufacturing hub
						</Text>
						.
					</Text>
				</Box>
			</Box>
			<Box width="100%" height="2px" bgColor="primary.200" />
			<Text
				variant="blogAnswer"
				lineHeight="30px"
				pt="18px"
				fontStyle="italic"
				p="12px 12px 0px"
				fontWeight="500"
			>
				<Text as="span" fontWeight="700" fontStyle="normal">
					#TheContext by IVCA
				</Text>{" "}
				– features opinion makers from the alternate investing industry with
				strong focus on India as an investment destination. Watch this space for
				new announcements in the sector, viewpoints on investment themes,
				emerging trends, economic reports, analysis and latest industry
				insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with&nbsp;
				{/* The content in this section is curated by Team IVCA. For any feedback,
        connect with&nbsp; */}
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default TheContextGlobalPowerHouse;
